import React, { FC, memo } from 'react'
import { Collapse } from 'antd'
import { useIntl } from 'react-intl'

const { Panel } = Collapse

const RegistryProblems: FC = () => {
    const intl = useIntl()

    return (
        <div>
            <Collapse accordion bordered={false} expandIconPosition="right" className="landing-page-faq-collapse">
                <Panel
                    header="为什么网页无法成功登录？"
                    key="1"
                    className="landing-page-faq-collapse-header"
                >
                    <p>请尝试以下方式排查您的问题：</p>
                    <p>1. 请检查观看码的英文、数字大、小写是否与您收到的通知函完全一致。</p>
                    <p>2. 请手动输入您的观看码。</p>
                    <p>3. 刷新页面再次登录。如果以上尝试仍无法登录，请联系您的谷歌客户经理。</p>
                </Panel>
                <Panel
                    header="为什么只有画面没有声音？"
                    key="2"
                    className="landing-page-faq-collapse-header"
                >
                    <p>请检查主机以及网站的音源按键是否开启。</p>
                </Panel>
                <Panel
                    header="为什么能听到声音但看不到画面？"
                    key="3"
                    className="landing-page-faq-collapse-header"
                >
                    <p>请刷新页面，或是关闭与活动无关的网站。如果问题仍无法解决，请尝试以不同的浏览器开启网页。</p>
                </Panel>
                <Panel
                    header="为什么直播画面清晰度略显模糊？"
                    key="4"
                    className="landing-page-faq-collapse-header"
                >
                    <p>请先确认您的网络状态是否稳定，再尝试刷新页面确认直播画面是否恢复正常。</p>
                </Panel>
            </Collapse>
        </div>
    )
}

export default memo(RegistryProblems)
